import {ArrowLeft} from 'lucide-react';
import type {ReactNode} from 'react';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useMedia} from 'react-use';

import {ScrollArea} from '@/components/ui/scroll-area';
import {cn} from '@/utils/ui';

export type MenuSidebarProps = {
  children: ReactNode | ((isSmall: boolean) => ReactNode);
};

const MenuSidebar = ({children}: MenuSidebarProps) => {
  const {t} = useTranslation();
  const [isTablet, setIsTablet] = useState(false);

  const isTabletMedia = useMedia('(max-width: 1024px)');

  useEffect(() => {
    setIsTablet(isTabletMedia);
  }, [isTabletMedia]);

  return (
    <aside
      className={cn(
        'shadow-default',
        'sticky top-4',
        'flex flex-col',
        'h-screen overflow-hidden rounded-soft bg-card transition-all',
        'mt-4 mb-4 ml-4 max-h-[calc(100vh-32px)]',
        {
          'w-60': !isTablet,
          'w-16': isTablet,
        }
      )}
    >
      <ScrollArea>
        <div
          className={cn('sticky top-0 flex flex-row justify-end pt-4', {
            'justify-center': isTablet,
            'px-4': !isTablet,
          })}
        >
          <button
            onClick={() => {
              setIsTablet(!isTablet);
            }}
            className={cn(
              'transition-all',
              'inline-flex h-8 w-8 items-center justify-center rounded-full bg-neutral-light p-2 text-neutral',
              {
                'rotate-180 transform': isTablet,
              }
            )}
          >
            <ArrowLeft />
            <span className="sr-only">{t('Toggle menu')}</span>
          </button>
        </div>
        {typeof children === 'function' ? children(isTablet) : children}
      </ScrollArea>
    </aside>
  );
};

export default MenuSidebar;
